/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import campingPhotoDesktop from './camping.webp';
import campingPhotoMobile from './camping-mobile.webp';
import ticketsPhotoDesktop from './tickets.webp';
import ticketsPhotoMobile from './tickets-mobile.webp';
import permitsPhotoDesktop from './permits.webp';
import permitsPhotoMobile from './permits-mobile.webp';
import dayUsePhotoDesktop from './venues.webp';
import dayUsePhotoMobile from './venues-mobile.webp';
import passesImage from './passes.webp';
import passesMobileImage from './passes-mobile.webp';
import huntingImage from './fishing.webp';
import huntingMobileImage from './fishing-mobile.webp';
import lotteriesImage from './lotteries.webp';
import lotteriesMobileImage from './lotteries-mobile.webp';

import type { QuickPromosType } from '../../../../types/quickPromos';

const imageHeight = '125px';

export const quickPromos: QuickPromosType = [
    {
        title: 'Camping & Lodging',
        image: campingPhotoDesktop,
        mobileImage: campingPhotoMobile,
        imageAlt: 'Camping and Lodging',
        url: '/search?inventory_type=camping',
        height: `${imageHeight}`,
        inventoryType: ['camping'],
        labelType: 'camping',
    },
    {
        title: 'Tickets & Tours',
        image: ticketsPhotoDesktop,
        mobileImage: ticketsPhotoMobile,
        imageAlt: 'Tickets and Tours',
        url: '',
        height: `${imageHeight}`,
        inventoryType: ['ticketfacility', 'tours'],
        labelType: 'tickets',
    },
    {
        title: 'Permits',
        image: permitsPhotoDesktop,
        mobileImage: permitsPhotoMobile,
        imageAlt: 'Permits',
        url: '',
        height: `${imageHeight}`,
        inventoryType: ['permits'],
        labelType: 'permits',
    },
    {
        title: 'Activity Passes',
        image: passesImage,
        mobileImage: passesMobileImage,
        imageAlt: 'Learn More About Activity Passes',
        url: '/search?inventory_type=activity%20pass&use_location=false&clear=true',
        height: `${imageHeight}`,
        inventoryType: [],
        labelType: 'passes',
    },
    {
        title: 'Lotteries',
        image: lotteriesImage,
        mobileImage: lotteriesMobileImage,
        imageAlt: 'Upcoming Lotteries',
        url: '/lottery/available',
        height: `${imageHeight}`,
        inventoryType: [],
        labelType: 'lotteries',
    },
    {
        title: 'Hunting & Fishing',
        image: huntingImage,
        mobileImage: huntingMobileImage,
        imageAlt: 'Recreation Activities',
        url: '/search?activity_tags=featured-hunt-fish&use_location=false&clear=true',
        height: `${imageHeight}`,
        inventoryType: [],
        labelType: 'hunting',
    },
    {
        title: 'Day Use & Venues',
        image: dayUsePhotoDesktop,
        mobileImage: dayUsePhotoMobile,
        imageAlt: 'Day Use',
        url: '/search?inventory_type=day%20use&inventory_type=venues',
        height: `${imageHeight}`,
        inventoryType: ['dayuse', 'venuereservations'],
        labelType: 'venues',
    },
];

// cSpell:ignore activitypass, dayuse, venuereservations, recarea, ticketfacility
